export default {
  version: "v1",
  config: {
    visState: {
      filters: [
        {
          id: "me",
          dataId: "action",
          name: "day",
          type: "time",
          view: "enlarged",
        },
      ],
      layers: [
        {
          id: "1s8r5md",
          type: "cluster",
          config: {
            dataId: "action",
            label: "cluster location",
            color: [255, 0, 0],
            columns: {
              lat: "latitude",
              lng: "longitude",
              altitude: null,
            },
            isVisible: true,
            visConfig: {
              worldUnitSize: 0.8,
              resolution: 8,
              colorRange: {
                name: "ColorBrewer GnBu-6",
                type: "sequential",
                category: "ColorBrewer",
                colors: ["#b71c52"],
                reversed: false,
              },
            },
          },
        },
        {
          id: "7otjdz",
          type: "point",
          config: {
            dataId: "action",
            label: "point location",
            columns: {
              lat: "latitude",
              lng: "longitude",
              altitude: null,
            },
            isVisible: true,
            visConfig: {
              radius: 10,
              fixedRadius: false,
              opacity: 0.8,
              outline: false,
              thickness: 2,
              colorRange: {
                name: "Ice And Fire",
                type: "diverging",
                category: "Uber",
                colors: ["#ffff66"],
                reversed: true,
              },
            },
          },
        },
      ],
      interactionConfig: {
        tooltip: {
          fieldsToShow: {
            action: [
              "country",
              "day",
              "latitude",
              "longitude",
              "canTimestamp",
              "gpsTimestamp",
              "batterySoc",
              "odometer",
            ],
          },
          enabled: true,
        },
      },
    },
  },
};
